import { ClienteAnaliseMercadoRAPClienteResponse } from './cliente-analise-mercado-rap-cliente.response';
import { ClienteAnaliseMercadoRAPTotal } from './cliente-analise-mercado-rap-total.response';
import { ClienteAnaliseMercadoRAPLegendaResponse } from './cliente-analise-mercado-rap-legenda.response';

/** Response com os dados da consulta da Análise de Mercado RAP */
export class ClienteAnaliseMercadoRAPResponse {
    clientes: ClienteAnaliseMercadoRAPClienteResponse[];
    total: ClienteAnaliseMercadoRAPTotal;
    legenda: ClienteAnaliseMercadoRAPLegendaResponse;

    constructor(props: Partial<ClienteAnaliseMercadoRAPResponse>) {
        Object.assign(this, props);

        // Clientes
        if (props.clientes && Array.isArray(props.clientes)) {
            this.clientes = props.clientes.map(cliente => new ClienteAnaliseMercadoRAPClienteResponse(cliente));
        } else {
            this.clientes = [];
        }

        // Total
        if (props.total) {
            this.total = new ClienteAnaliseMercadoRAPTotal(props.total);
        }

        // Legenda
        if (props.legenda) {
            this.legenda = new ClienteAnaliseMercadoRAPLegendaResponse(props.legenda);
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ClienteAnaliseMercadoRAPResponse {
        return new ClienteAnaliseMercadoRAPResponse(JSON.parse(json));
    }

    /** Retorna o Customer Share Ótimo */
    getCustomerShareOtimo(): number {
        return this.legenda?.customerShareOtimo ?? null;
    }

    /** Retorna o Customer Share Bom */
    getCustomerShareBom(): number {
        return this.legenda?.customerShareBom ?? null;
    }

    /** Retorna o Customer Share Razoável */
    getCustomerShareRazoavel(): number {
        return this.legenda?.customerShareRazoavel ?? null;
    }

    /** Obtem um cliente pelo seu ID */
    getCliente(idCliente: number): ClienteAnaliseMercadoRAPClienteResponse {
        if (!idCliente) {
            return null;
        }
        return this.clientes?.find(clienteFilter =>  clienteFilter.idCliente === idCliente) ?? null;
    }

    /** Adiciona um novo cliente ao array */
    addCliente(cliente: ClienteAnaliseMercadoRAPClienteResponse) {
        if (!cliente) {
            return;
        }

        // Adiciona o cliente no início do array
        this.clientes.unshift(cliente);

        // Recalculando totais
        this.recalcularTotais();
    }


    /** Atualiza um cliente */
    updateCliente(cliente: ClienteAnaliseMercadoRAPClienteResponse) {
        if (!cliente) {
            return;
        }
        const index = this.clientes.findIndex(c => c.idCliente === cliente.idCliente);
        if (index !== -1) {
            this.clientes[index] = cliente;
        }

        // Recalculando totais
        this.recalcularTotais();
    }

    /** Remove um cliente do array pelo seu ID */
    removeCliente(idCliente: number) {
        if (!idCliente) {
            return;
        }
        const index = this.clientes.findIndex(c => c.idCliente === idCliente);
        if (index !== -1) {
            this.clientes.splice(index, 1);
        }

        // Recalculando totais
        this.recalcularTotais();
    }

    /** Recalcula os totais da consulta com base nos valores dos clientes */
    recalcularTotais() {
        if (!this.total){
            return;
        }
        this.total.recalcular(this.getCustomerShareOtimo(), this.getCustomerShareBom(), this.getCustomerShareRazoavel(), this.clientes);
    }
}
